import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { PanelFooter, PanelHeader } from 'components/Panel'

import { Offcanvas } from 'react-bootstrap'

function VerCargoDirectiva(props) {
	const { cargo, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver cargo de directiva" />
			<Offcanvas.Body>
				<h1>Datos del cargo de la Junta Directiva</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{cargo.id}</td>
								</tr>
								<tr>
									<th>Cargo</th>
									<td>{cargo.nombre}</td>
								</tr>
								<tr>
									<th>Contenido</th>
									<td>{cargo.contenido || '-'}</td>
								</tr>
								<tr>
									<th>Orden</th>
									<td>{cargo.orden || '-'}</td>
								</tr>
							</tbody>
						</Table>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerCargoDirectiva